import React from 'react';

const TicketChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M10 13v-2h4v2zm6 5V6h-.4C15 7.4 13.8 8.4 12 8.4S9 7.4 8.4 6H8v12h.4c.6-1.4 1.8-2.4 3.6-2.4s3 1 3.6 2.4zM14 4h4v16h-4s0-2.4-2-2.4-2 2.4-2 2.4H6V4h4s0 2.4 2 2.4S14 4 14 4z" />
    </svg>
);

TicketChunkySvg.displayName = 'TicketChunkySvg';
export default TicketChunkySvg;
